import React, { useState, useRef, useEffect } from 'react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

interface EditableTitleProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  placeholder?: string;
  isEditMode: boolean;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'span';
}

export function EditableTitle({ value, onChange, className, placeholder = 'Titre...', isEditMode, as: Component = 'span' }: EditableTitleProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [tempValue, setTempValue] = useState(value);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => { setTempValue(value); }, [value]);
  useEffect(() => { if (isEditing && inputRef.current) { inputRef.current.focus(); inputRef.current.select(); } }, [isEditing]);

  const handleStartEdit = () => { if (isEditMode) { setIsEditing(true); setTempValue(value); } };
  const handleSave = () => {
    const trimmed = tempValue.trim();
    if (trimmed && trimmed !== value) onChange(trimmed); else if (!trimmed) setTempValue(value);
    setIsEditing(false);
  };
  const handleCancel = () => { setTempValue(value); setIsEditing(false); };
  const handleKeyDown = (e: React.KeyboardEvent) => { if (e.key === 'Enter') { e.preventDefault(); handleSave(); } else if (e.key === 'Escape') { e.preventDefault(); handleCancel(); } };

  if (!isEditMode || !isEditing) {
    return (
      <Component className={cn('cursor-pointer transition-colors', isEditMode && 'hover:bg-accent/50 hover:text-accent-foreground px-1 rounded', className)} onClick={handleStartEdit} title={isEditMode ? 'Cliquer pour éditer' : undefined}>
        {value || placeholder}
      </Component>
    );
  }

  return (
    <Input ref={inputRef} value={tempValue} onChange={(e) => setTempValue(e.target.value)} onBlur={handleSave} onKeyDown={handleKeyDown} className={cn('min-w-0 h-auto py-0 px-1 border-dashed', className)} placeholder={placeholder} />
  );
}


